import "../../../node_modules/@codat/orchard-ui/dist/index.css";

import { BrowserRouter } from "react-router-dom";
import styles from "./App.module.scss";

import AppRouter from "./AppRouter";

const App = () => {
  return (
    <div className={styles.app}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
};
export default App;
